"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThemeProvider;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _reactJss = require("react-jss");

var _jss = require("./jss");

var _base = _interopRequireDefault(require("./base"));

var RAMBLER_UI_THEME_COUNTER = '__RAMBLER_UI_THEME_COUNTER__';

function ThemeProvider(props) {
  var context = (0, _react.useContext)(_jss.ThemeProviderContext);
  var currentTheme = (0, _react.useRef)();
  var currentParentTheme = (0, _react.useRef)();
  var resultTheme = (0, _react.useRef)();
  var jss = props.jss || context.jss || _jss.globalJss;
  var sheetsRegistry = props.sheetsRegistry || context.sheetsRegistry || _jss.globalSheetsRegistry;
  var themeContext = (0, _react.useMemo)(function () {
    return {
      jss: jss,
      sheetsRegistry: sheetsRegistry
    };
  }, [jss, sheetsRegistry]);
  var themeId = (0, _react.useMemo)(function () {
    return sheetsRegistry[RAMBLER_UI_THEME_COUNTER] == null ? sheetsRegistry[RAMBLER_UI_THEME_COUNTER] = 0 : ++sheetsRegistry[RAMBLER_UI_THEME_COUNTER];
  }, [sheetsRegistry]);
  var generateId = (0, _react.useMemo)(function () {
    return props.generateId || (0, _jss.createGenerateId)(themeId);
  }, [props.generateId, themeId]);
  var getResultTheme = (0, _react.useCallback)(function (parentTheme) {
    var _props$theme = props.theme,
        theme = _props$theme === void 0 ? _base.default : _props$theme;

    if (currentTheme.current !== theme || currentParentTheme.current !== parentTheme) {
      resultTheme.current = parentTheme ? (0, _deepmerge.default)(parentTheme, theme) : theme;
      currentParentTheme.current = parentTheme;
      currentTheme.current = theme;
    }

    return resultTheme.current;
  }, [props.theme]);
  return _react.default.createElement(_jss.ThemeProviderContext.Provider, {
    value: themeContext
  }, _react.default.createElement(_reactJss.JssProvider, {
    jss: jss,
    registry: sheetsRegistry,
    generateId: generateId
  }, _react.default.createElement(_jss.JssThemeProvider, {
    theme: getResultTheme
  }, props.children)));
}

ThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  theme: _propTypes.default.object,
  jss: _propTypes.default.object,
  sheetsRegistry: _propTypes.default.object,
  generateId: _propTypes.default.func,
  children: _propTypes.default.node
} : {};